import React, { useState } from 'react';
import { useI18n } from '../i18n';
import { Plus, Minus } from 'lucide-react';

export default function Faq() {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" style={{ padding: '44px 24px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>
        <p style={{ fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--hm-gold)', margin: 0 }}>{t.faq.eyebrow}</p>
        <h2 className="font-sora" style={{ margin: '10px 0 0', fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.02em' }}>{t.faq.title}</h2>
        <div style={{ marginTop: 30 }}>
          {t.faq.items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} style={{ borderTop: '1px solid var(--color-divider)' }}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: '22px 0', background: 'transparent', border: 0, cursor: 'pointer', textAlign: 'left' }}>
                  <span style={{ fontSize: 17, fontWeight: 600, color: 'var(--color-text)' }}>{f.q}</span>
                  <span style={{ flex: '0 0 auto', color: 'var(--hm-gold)' }}>{isOpen ? <Minus size={20} /> : <Plus size={20} />}</span>
                </button>
                <div style={{ maxHeight: isOpen ? 260 : 0, overflow: 'hidden', transition: 'max-height .35s ease' }}>
                  <p style={{ margin: '0 0 22px', fontSize: 14.5, lineHeight: 1.65, color: 'var(--color-neutral-400)', maxWidth: '64ch' }}>{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
